module.exports = __webpack_public_path__ + "img/home_top_img_logo@3x.b00ec952.png";